import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "h6 text-center" }
const _hoisted_2 = { class: "font-weight-bold font-primary" }
const _hoisted_3 = { class: "form-group mb-2" }
const _hoisted_4 = ["min", "step", "max"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<datalist class=\"dl\" id=\"loanRange\"><option value=\"7\" label=\"7\"></option><option value=\"8\" label=\"8\"></option><option value=\"9\" label=\"9\"></option><option value=\"10\" label=\"10\"></option><option value=\"11\" label=\"11\"></option><option value=\"12\" label=\"12\"></option><option value=\"13\" label=\"13\"></option><option value=\"14\" label=\"14\"></option><option value=\"15\" label=\"15\"></option><option value=\"16\" label=\"16\"></option><option value=\"17\" label=\"17\"></option><option value=\"18\" label=\"18\"></option><option value=\"19\" label=\"19\"></option><option value=\"20\" label=\"20\"></option><option value=\"21\" label=\"21\"></option><option value=\"22\" label=\"22\"></option><option value=\"23\" label=\"23\"></option><option value=\"24\" label=\"24\"></option><option value=\"25\" label=\"25\"></option><option value=\"26\" label=\"26\"></option><option value=\"27\" label=\"27\"></option><option value=\"28\" label=\"28\"></option><option value=\"29\" label=\"29\"></option><option value=\"30\" label=\"30\"></option></datalist>", 1)
const _hoisted_6 = { class: "h6 text-center" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        class: "range",
        min: _ctx.min,
        step: _ctx.step,
        max: _ctx.max,
        type: "range",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        name: "loan",
        style: {"width":"100%"},
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setValues && _ctx.setValues(...args))),
        list: "loanRange"
      }, null, 40, _hoisted_4), [
        [_vModelText, _ctx.value]
      ]),
      _hoisted_5
    ]),
    _createElementVNode("h4", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        (_ctx.pluralize === 'amount')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " $" + _toDisplayString(_ctx.$filters.pluralizeAmount(_ctx.value)), 1))
          : _createCommentVNode("", true),
        (_ctx.pluralize === 'days')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$filters.pluralizeDays(_ctx.value)), 1))
          : (_ctx.pluralize === 'months')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$filters.pluralizeMonths(_ctx.value)), 1))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}